export default {
	name: null,
	email: null,
	id: null,
	profilePicture: null,
	role: null,
	changePasswordAccessToken: null
}